// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__3SVh5","row":"styles_row__2rSEH"};